import { useDepositAccountInfo } from './hooks';
import { DepositAccountTemplate } from 'views/components/templates/establishes';
import { Gauge, GaugeSP, getGaugeValue } from 'views/components/atoms/gauge';
import { useLocation } from 'react-router-dom';

export const DepositAccount = () => {
  const tempProps = useDepositAccountInfo();
  const location = useLocation();

  return (
    <form className="establishFormSP" onSubmit={tempProps.formik.handleSubmit}>
      <GaugeSP currentPage={getGaugeValue(location.pathname)} />
      <DepositAccountTemplate {...tempProps} />
    </form>
  );
};
